/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const IssueType = {
    Unknown: 'Unknown',
    Shortlanded: 'Shortlanded',
    MissingRailcar: 'MissingRailcar',
    CustomsPending: 'CustomsPending',
    CustomsRefused: 'CustomsRefused',
    CustomsInspectionRequired: 'CustomsInspectionRequired',
    MissingOperator: 'MissingOperator',
    MissingConsignee: 'MissingConsignee',
    MissingUnNumberOfUnitLabel: 'MissingUNNumberOfUnitLabel',
    UnknownCompany: 'UnknownCompany',
    MissingCompany: 'MissingCompany',
    Overlanded: 'Overlanded',
} as const;

export type IssueType = typeof IssueType[keyof typeof IssueType];



